export const getUserContextProps = () => window?.SRI_STUDENT_UI_CONTEXT?.props as unknown as any;
export const getUserContextDistrictId = () => window?.SRI_STUDENT_UI_CONTEXT?.DISTRICT_ID;
export const getUserContextHighSchoolId = () => window?.SRI_STUDENT_UI_CONTEXT?.HIGHSCHOOL_ID;
export const getUserContextToggles = () => window?.SRI_STUDENT_UI_CONTEXT?.toggles;
export const getUserContextState = () => window?.SRI_STUDENT_UI_CONTEXT?.state || null;
export const getUserContextMockStudents = () =>
  window?.SRI_STUDENT_UI_CONTEXT?.mockStudents || null;
